import React from 'react'
import newicon from './img/newicon.gif'
import horn from './img/horn.png'
import impIns from './IMPORTANT INSTRUCTIONS FOR MOCK & MAIN EXAMINATION.pdf'
import { Link } from 'react-router-dom'
function RightSideBar() {
    return (
        <div className='rightSidebarheader'>
            <div className="boxdesignNews" >



                <h5 className="newsHeading" style={{ display: 'flex' }}>
                    News &amp; Events
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img src={horn} width="10%" />
                </h5>
                <nav id="sidebar">
                    <ul className="list-unstyled components">
                        {/* <li style={{ paddingBottom: '2px', listStyle: 'none', fontSize: '1rem' }}>
            <a style={{ fontSize: '0.8rem' ,display:'flex',justifyContent:'space-around'}} className="btn btn-primary btn-block btn-lg text-white"
                href="https://counselling.aicee.in/spot-login"> AICEE 2023 Counselling
                Portal(Spot Round New User) <sup><img src={newicon} alt='new' /></sup> </a>
                
        </li> */}


                        {/* <li style={{ paddingBottom: '2px', listStyle: 'none', fontSize: '1rem' }}>
            <a style={{ fontSize: '0.8rem' ,display:'flex',justifyContent:'space-around'}} className="btn btn-primary btn-block btn-lg text-white" href="#"
               > AICEE 2023 Counselling Portal(Registered Students) <sup><img src={newicon} alt='new' /></sup> </a>
            
        </li> */}
                        {/* <li style={{ paddingBottom: '2px', listStyle: 'none', fontSize: '1rem' }}>
            <a style={{ fontSize: '0.8rem' ,display:'flex',justifyContent:'space-around'}} className="btn btn-primary btn-block btn-lg text-white" href="https://onlineexam.aicee.in/"
                > AICEE 2023 Phase 2 Online Exam Link <sup><img src={newicon} alt='new' /></sup> </a>

        </li> */}
                        <li style={{ listStyle: 'none', marginTop: '5px' }}>
                            <a style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white"
                                href="https://counselling.aicee.in/special-round-login"
                                // onClick={() => { alert("AICEE 2026 (Phase-2) Mock Examination will be active from 1st May, 2026 04:00 PM  .") }}
                                target='_blank'
                            > AICEE 2026 Counselling (Special Round)
                                <sup><img src={newicon} alt='new' /></sup> </a>

                        </li>
                        {/* <li style={{ listStyle: 'none', marginTop: '5px' }}>
                            <a style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white"
                                href="https://exam.aicee.in/"
                                // onClick={() => { alert("AICEE 2026 (Phase-2) Mock Examination will be active from 1st May, 2026 04:00 PM  .") }}
                                target='_blank'
                            > AICEE 2026 Online MOCK EXAMINATION
                                <sup><img src={newicon} alt='new' /></sup> </a>

                        </li> */}
                        <li style={{ listStyle: 'none' }}>
                            <a style={{ fontSize: '14px', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white mt-1"

                                href="https://onlineexam.aicee.in/"
                                // onClick={()=>{alert("AICEE 2026 Main Examination portal will open from 30th Jan,2026.")}}
                                //  onClick={() => { alert("AICEE 2026 (Phase-2) Main Examination  link will be activated by 2nd May, 2026 06:00 PM") }}
                                target='_blank'
                            > AICEE 2026 Main Examination
                                <sup><img src={newicon} alt='new' /></sup> </a>

                        </li>
                        <li style={{ listStyle: 'none' }}>
                            <a style={{ fontSize: '14px', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white mt-1" href="https://docs.aicee.in/IMPORTANT+INSTRUCTIONS+FOR+MOCK+%26+MAIN+EXAMINATION.pdf" target='_blank'
                            > IMPORTANT INSTRUCTIONS FOR MOCK & MAIN EXAMINATION
                                <sup><img src={newicon} alt='new' /></sup> </a>
                        </li>


                        <li style={{ listStyle: 'none' }}>
                            <a style={{ fontSize: '14px', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white mt-1" href="https://counselling.aicee.in/" target='_blank'
                            > AICEE 2026 Counselling Portal
                                <sup><img src={newicon} alt='new' /></sup>
                            </a>

                        </li>
                        <li style={{ listStyle: 'none', textTransform: 'uppercase' }}>
                            {/* <a style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white mt-1" href="https://counselling.aicee.in/spot/student/login" target='_blank' */}
                            <a style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white mt-1" href="https://admitcard.aicee.in" target='_blank'
                            > AICEE 2026 Admit Card (Phase-2)
                                <sup><img src={newicon} alt='new' /></sup> 
                            </a>

                        </li>


                        <li style={{ listStyle: 'none', marginTop: '3px' }}>
                            <a style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white"
                                href="https://student.aicee.in/rank-card"
                                // onClick={() => { alert("AICEE 2025 (Phase-3) Result will get published on 4th July, 2025 at 7:00 PM") }}
                                // href='#'
                                target='_blank'
                            > AICEE 2026 Results
                                <sup><img src={newicon} alt='new' /></sup>
                            </a>

                        </li>
                        <li style={{ listStyle: 'none', marginTop: '3px' }}>
                            <a style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'space-around' }} className="btn btn-primary btn-block btn-lg text-white"
                                href="/refund-login"
                                // onClick={()=>{alert("Refund Claim Process for 2026 will start from 20th June, 2026 07:00 PM")}}
                                // href='#'
                                target='_blank'
                            > AICEE 2026 Refund Portal
                                <sup><img src={newicon} alt='new' /></sup>
                            </a>
                        </li>
                        <li style={{ listStyle: 'none' }}>
                            <span className="newspara" style={{ fontWeight: 'bold' }}>
                                <Link style={{ display: 'flex', justifyContent: 'space-around' }} to='/sample-question-paper-2023'>Download AICEE Sample Paper 2026 <sup><img src={newicon} alt='new' /></sup></Link>
                            </span>
                        </li>
                        <li style={{ listStyle: 'none' }}>
                            <span className="newspara" style={{ fontWeight: 'bold' }}>
                                <a href={`https://docs.aicee.in/FAQ's.pdf`} target='_blank'> FREQUENTLY ASKED QUESTIONS (FAQs) AICEE-2026
                                </a>
                            </span>
                        </li>
                    </ul>
                </nav>
            </div>
            <div className="boxdesignBottomLinks">
                <nav id="sidebar">
                    <ul className="list-unstyled components">
                        <li style={{ listStyle: 'none' }}>
                            <a  href="https://institute.aicee.in/institute/auth" target='_blank' className="parentLink"> Institutions
                                Login </a>
                        </li>
                        <li style={{ listStyle: 'none' }}>
                            <Link to="/contact" className="parentLink">Contact Now </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default RightSideBar 